export const removeWhitespace = (string: string) => string.replace(/\s/g, '').trim();
export const isNotEmptyOrNull = (value: string | undefined | null) => !!value && removeWhitespace(value).length > 0;
export const stringValueCheck = (value: string | undefined | null) => value || '';
export const isEmpty = (value: string | undefined | null) => !value || removeWhitespace(value).length === 0;
